const COMMENTS = [
  {
    name: '爱吃草莓酱',
    avatar: '草',
    time: '2小时前',
    content: '谜妹漫画的韩漫资源真的太全了！找了很久的《她的私密日记》在这里居然有完整版，画质也超清晰。下拉翻页的体验比翻页式的舒服太多了，一口气看了三十话停不下来。',
    likes: '328',
    comic: '她的私密日记',
  },
  {
    name: '深夜追漫人',
    avatar: '深',
    time: '5小时前',
    content: '作为一个悬疑漫画爱好者，这里简直是天堂。之前在其他平台看的《第七层密室》总是缺章少页，谜妹这边更新又快又全。悬疑分类做得特别好，推荐算法也很准。',
    likes: '215',
    comic: '第七层密室',
  },
  {
    name: '樱花飘落时',
    avatar: '樱',
    time: '1天前',
    content: '国漫板块要单独夸一夸！《长安幻夜行》的画风真的太美了，每一帧都能当壁纸。站内国漫的分类很细致，古风、都市、奇幻都有单独分类，找漫超方便！强烈安利给所有国漫爱好者。',
    likes: '486',
    comic: '长安幻夜行',
  },
  {
    name: '二次元打工人',
    avatar: '二',
    time: '1天前',
    content: '日漫经典库真的绝了！小时候追过的那些经典日漫居然都有收录，一口气重温了好几部童年回忆。而且还有日漫新番的同步更新，老漫和新番两不误，谜妹漫画真的是良心平台。',
    likes: '172',
    comic: '夏日幻梦物语',
  },
  {
    name: '摸鱼大师',
    avatar: '摸',
    time: '2天前',
    content: '每天上班摸鱼必备！搞笑漫画分类里的《废柴逆袭手册》笑到我差点被老板发现。更新频率也很稳定，基本每天都有新内容。免费加质量高的平台真的不多了，谜妹漫画且用且珍惜。',
    likes: '593',
    comic: '废柴逆袭手册',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            听听漫画爱好者们怎么说
          </p>
        </div>

        <div className="space-y-4">
          {COMMENTS.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading font-bold text-sm md:text-base flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center flex-wrap gap-2 mb-2">
                    <h3 className="font-medium text-sm md:text-base text-foreground-900">{comment.name}</h3>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      在看《{comment.comic}》
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-thumb-up-line"></i>
                      {comment.likes}
                    </span>
                    <span className="cursor-pointer hover:text-primary-500 transition-colors">回复</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}